import { Dashboard } from "../../../dashboards/components/Dashboard"
import { DeviceReport } from "../components/DeviceReport"

type Props = Readonly<{}>

export function SupportReportsHome({}: Props) {
    return (
        <Dashboard>
            <DeviceReport />
        </Dashboard>
    )
}
